import PropTypes from 'prop-types';

import Page from 'core/components/Page';
import { PageIndent } from 'core/components/Wrappers';
import Text from 'core/components/Text';
import Link from 'core/components/Link';

import H2 from 'core/components/H2';
import Indent from 'core/components/Wrappers/Indent';

import styles from 'core/components/LegalPage/index.styl';

/**
 * @author Aminev Ramil <r.aminev@rambler-co.ru>
 */
function RulesRecommenders({ mail }) {
  return (
    <Page>
      <PageIndent>
        <Text>
          <div className={styles.content}>
            <Indent top={40} bottom={40}>
              <H2>Правила применения рекомендательных технологий</H2>
            </Indent>
            <p>Вступили в силу 01.12.2023</p>
            <Indent bottom={40} >
              <b>На&nbsp;информационном ресурсе при применении информационных технологий предоставления информации осуществляется сбор, систематизация и&nbsp;анализ сведений, относящихся к&nbsp;предпочтениям пользователей сети &laquo;Интернет&raquo;, находящихся на&nbsp;территории Российской Федерации</b>
              <i>Настоящие правила применения рекомендательных технологий (Правила) определяют общие условия и&nbsp;правила применения информационных технологий предоставления информации на&nbsp;основе сбора, систематизации и&nbsp;анализа сведений, относящихся к&nbsp;предпочтениям Пользователей (далее&nbsp;&mdash; &laquo;Рекомендательные технологии&raquo;).</i>
              <i>Правила являются неотъемлемой частью Условий использования Ресурса.</i>
            </Indent>
            <ol>
              <li>
                Для функционирования Рекомендательных технологий используются следующие виды сведений, относящиеся к&nbsp;предпочтениям Пользователей и&nbsp;источники их&nbsp;получения:
                <ol>
                  <li>Для работы Рекомендательных технологий используются данные, предоставляемые Пользователем в&nbsp;результате использования браузера или мобильного приложения, запускаемого на&nbsp;устройстве Пользователя и&nbsp;взаимодействующего с&nbsp;Ресурсом.</li>
                  <li>Каждому Пользователю присваивается случайный идентификатор Пользователя, который представляет собой набор букв, цифр и&nbsp;специальных символов.</li>
                  <li>В&nbsp;совокупности с&nbsp;идентификатором Пользователя используются следующие данные о&nbsp;взаимодействиях Пользователя с&nbsp;Ресурсом, такие как:</li>
                  <ul>
                    <li>данные о&nbsp;просмотрах страниц и&nbsp;материалов Ресурса;</li>
                    <li>данные о&nbsp;просмотрах анонсов материалов Ресурса;</li>
                    <li>данные о&nbsp;кликах на&nbsp;анонсы материалов Ресурса.</li>
                  </ul>
                </ol>
              </li>
              <li>
                Данные о&nbsp;взаимодействиях Пользователя с&nbsp;Ресурсом используются для выявления закономерностей и&nbsp;паттернов предпочтений Пользователя на&nbsp;основе методов коллаборативной фильтрации и&nbsp;машинного обучения.
              </li>
              <li>
                На&nbsp;основе выявленных закономерностей и&nbsp;паттернов предпочтений Пользователя формируются рекомендации в&nbsp;виде списка дополнительных материалов на&nbsp;Ресурсе с&nbsp;которыми Пользователь еще не&nbsp;взаимодействовал.
              </li>
              {mail && (
                <li>Адрес электронной почты для направления юридически значимых сообщений по вопросам применения рекомендательных технологий: <Link to={`mailto:${mail}`} type='tertiary'>{mail}</Link>
                </li>
              )}
            </ol>
          </div>
        </Text>
      </PageIndent>
    </Page>
  );
}

RulesRecommenders.propTypes = {
  mail: PropTypes.string,
};

export default RulesRecommenders;
